var React = require('react');

function GlyphInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.723939 2.27614C0.203239 1.75544 0.203239 0.911223 0.723939 0.390524C1.24464 -0.130175 2.08886 -0.130175 2.60956 0.390524L9.27622 7.05719C9.79692 7.57789 9.79692 8.42211 9.27622 8.94281L2.60956 15.6095C2.08886 16.1302 1.24464 16.1302 0.723938 15.6095C0.203239 15.0888 0.203239 14.2446 0.723938 13.7239L6.4478 8L0.723939 2.27614Z","fill":"white"}));
}

GlyphInline.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = GlyphInline;

GlyphInline.default = GlyphInline;
